import { render, staticRenderFns } from "./ApruveAccountView.vue?vue&type=template&id=53863d8b&scoped=true"
import script from "./ApruveAccountView.vue?vue&type=script&lang=js"
export * from "./ApruveAccountView.vue?vue&type=script&lang=js"
import style0 from "./ApruveAccountView.vue?vue&type=style&index=0&id=53863d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53863d8b",
  null
  
)

export default component.exports